import React from "react";

const SkipIcon = () => {
  return (
    <svg
      width="25"
      height="28"
      viewBox="0 0 25 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.5 0L25 7V21L12.5 28L0 21V7L12.5 0Z" fill="#336589" />
      <path
        d="M4.81172 18.12C3.08172 18.12 2.29172 17.44 2.29172 15.95H3.75172C3.75172 16.61 4.12172 16.9 4.85172 16.9C5.51172 16.9 5.84172 16.66 5.84172 16.17C5.84172 15.61 5.48172 15.37 4.47172 15.21C2.96172 14.97 2.39172 14.41 2.39172 13.17C2.39172 11.78 3.24172 11.08 4.86172 11.08C6.46172 11.08 7.25172 11.76 7.25172 13.19H5.79172C5.79172 12.6 5.48172 12.31 4.83172 12.31C4.21172 12.31 3.89172 12.57 3.89172 13.02C3.89172 13.53 4.24172 13.76 5.20172 13.9C6.79172 14.13 7.34172 14.74 7.34172 16.02C7.34172 17.43 6.51172 18.12 4.81172 18.12ZM8.39648 18V11.2H9.89648V14.17L12.2065 11.2H13.9265L11.7365 13.99L13.9565 18H12.2465L10.6965 15.18L9.89648 16.2V18H8.39648ZM14.6172 18V11.2H16.1172V18H14.6172ZM17.6152 18V11.2H20.3052C22.0252 11.2 22.7552 11.86 22.7552 13.42C22.7552 14.97 22.0252 15.62 20.3052 15.62H19.1152V18H17.6152ZM19.1152 14.34H20.1752C20.9352 14.34 21.2552 14.06 21.2552 13.41C21.2552 12.76 20.9352 12.48 20.1752 12.48H19.1152V14.34Z"
        fill="white"
      />
    </svg>
  );
};
export default SkipIcon;
